import i18next from 'i18next';

i18next.addResources('es_CL', 'CreditCards', {
  cardEndWith: '****{{lastDigits}}',
  withoutCreditCards: 'Aún no has guardado ninguna tarjeta.'
});
